export default __webpack_public_path__ + "static/media/image10.4eb5a29e.svg";